import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Lead from '../views/Lead.vue'
import Apply from '../views/Apply.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: "/lead/:job",
    name: "Lead",
    component: Lead,
  },
  {
    path: "/apply/:job",
    name: "Apply",
    component: Apply,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
